import {staffService} from "../services/staffService";
import {subscriptionManagerService} from "@/modules/appMarket/services/subscriptionManagerService";

const state = {
  used: null,
  bundled: null,
  purchased: null,
  total: null,
}

const getters = {
  used: (state)  => state.used,
  bundled: (state) => state.bundled,
  purchased: (state) => state.purchased,
  total: (state) => state.total,
}

const mutations = {
  setUsed(state, used) {
    state.used = used;
  },
  setBundled(state, bundled) {
    state.bundled = bundled;
  },
  setPurchased(state, purchased) {
    state.purchased = purchased;
  },
  setTotal(state, total) {
    state.total = total;
  },
}

const actions = {
  async loadStaffSlots({commit}, businessUid) {
    const staffSlots = await staffService.getStaffSlots(businessUid);
    commit('setUsed', staffSlots.used);
    commit('setBundled', staffSlots.quota.bundled);
    commit('setPurchased', staffSlots.quota.purchased);
    commit('setTotal', staffSlots.quota.total);
  },
  async purchaseItemSubscription({rootGetters, commit, getters, state}, params) {
    let res = await subscriptionManagerService.purchaseItemSubscription(params.item_uid, params.amount);
    if(res.error) {
      throw res.error
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
